module.exports = __webpack_public_path__ + "img/4_9.d22c76ca.png";